require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.0@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 427
// module chunks = 0 1